<template lang="pug">
.content.honey-content
  .row.honey-body
    .col-md-12
      .header Hũ mật ong
      .row
        .col-md-5
          .card.card-honey-total
            .box-honey-total
              .img-honey
                img(src="../../assets/images/achieve/ic_honeyJars@2x.png")
              .amount-honey
                .cur-total 
                  div Tổng hiện có
                  div {{formatNumber(totalHoney)}}
                .use-total 
                  div Số khả dụng
                  div {{formatNumber(totalHoney)}}
        .col-md-7
          //- .col-md-4
          //-   .card.card-store
          //-     .box-honey-store
          //-       .img-store
          //-         img(src='')
          //- .col-md-4
          //-   .card.card-store
          //-     .box-honey-store
          //-       .img-store
          //-         img(src='')
          //- .col-md-4
          //-   .card.card-store
          //-     .box-honey-store
          //-       .img-store
          //-         img(src='')
    .col-md-12
      .btn-honey-list
        button.btn.btn-honey-add-request Thêm yêu cầu đổi
        button.btn.btn-honey-manage-request Quản lý yêu cầu đổi
    .col-md-12
      .card.card-honey-action
        .card-content
          .box-list-honey(v-if="!mobile")
            .box-honey-header
              span STT
              span Hoạt động
              span Ngày giờ
            .box-honey-scroll
              .box-honey-items(v-for="(o, index) in honeyList")
                span {{index + 1}}
                span(v-if="!o.product_id") {{o.name}}
                  a.link-object(@click='' v-if="!o.product_id && o.set_id > 0") tên bộ đề
                  a.link-object(@click='' v-else-if="!o.product_id && o.qa_id") mã câu hỏi
                  a.link-object(v-else) ABCXYZ
                span(v-if="o.product_id") Bạn đã mua gói nạp thêm 
                span(v-if="!o.product_id && o.amount > 0") , bạn được tặng 
                span(v-if="!o.product_id && o.amount < 0") , bạn bị trừ 
                span.plus(v-if="o.amount > 0") + {{ formatNumber(o.amount) }} hũ mật ong
                span.minus(v-else) - {{ formatNumber(-o.amount) }} hũ mật ong
                span {{ o.created_at | moment }}
            observer(@intersect="onIntersected")
          .box-list-honey-kanban(v-else)
            .box-kanban-honey-default(v-if="honeyList && honeyList.length === 0")
              div CHƯA CÓ HOẠT ĐỘNG HONEYJARS
            .box-honey-scroll-kanban(v-if="honeyList && honeyList.length > 0")
              .box-kanban-honey(v-for="o in honeyList")
                div {{o.name}}
                  span(v-if="!o.product_id")
                    a.link-object(@click='' v-if="o.set_id > 0") tên bộ đề
                    a.link-object(@click='' v-else-if="o.qa_id") mã câu hỏi
                    a.link-object(v-else) ABCXYZ
                  span(v-if="!o.product_id && o.amount > 0") , bạn được tặng 
                  span(v-if="!o.product_id && o.amount < 0") , bạn bị trừ 
                  span.plus(v-if="o.amount > 0") + {{ formatNumber(o.amount) }} hũ mật ong
                  span.minus(v-else) - {{ formatNumber(-o.amount) }} hũ mật ong
                div {{ o.created_at | moment }}
            observer(@intersect="onIntersected")
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import moment from 'moment'
import Observer from '../Point/Observer'

export default {
  components: {
    Observer
  },
  data() {
    return {
      honeyList: {
        type: Array,
        default: () => ([])
      },
      offset: 10,
      limit: 10,
      totalHoney: 0,
      mobile: false
    }
  },
  methods: {
    formatNumber(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    async getHoneys(offset, limit) {
      await this.$apollo.query({
        query: gql(graphql.GET_POINTS_USER),
        variables: {
          uid: this.$store.getters.user,
          offset: offset,
          limit: limit,
          type: 3
        }
      }).then((res) => {
        if (res) {
          // console.log(res.data.history_point)
          this.points = res.data.history_point
        }
      })
    },
    async onIntersected() {
      // console.log(this.offset, this.limit)
      await this.getHoneys(this.offset, this.limit)
      this.offset += 10
      this.honeyList = [...this.honeyList, ...this.points]
    }
  },
  filters: {
    moment(date) {
      return moment(date).format('DD/MM/YYYY hh:mm') // format (h:mm:ss a)
    }
  },
  apollo: {
    honeyList: {
      query: gql(graphql.GET_POINTS_USER),
      variables() {
        return {
          uid: this.$store.getters.user,
          type: 3,
          offset: 0,
          limit: 10
        }
      },
      update: data => data.history_point
    },
    totalHoney: {
      query: gql(graphql.COUNT_POINT_USER),
      variables() {
        return {
          uid: this.$store.getters.user,
          type: 3
        }
      },
      update: data => data.history_point_aggregate.aggregate.sum.amount,
      skip() {
        return this.$store.getters.user == null
      }
    }
  },
  mounted() {
    if (window.innerWidth < 991) {
      this.mobile = true
    } else {
      this.mobile = false
    }
  },
  created() {
    this.$store.commit('setIsHomePage', false)
  }
}
</script>
<style lang="scss">
.honey-content {
  padding-top: 20px !important;
}
.honey-body {
  .header {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #5F6468;
  }
  .card-honey-total {
    margin-bottom: 5px;
    margin-top: 15px;
    border-radius: 5px;
    .box-honey-total {
      padding: 15px 0 15px 15px;
      .img-honey {
        width: 120px;
        display: inline-flex;
        img {max-width: 100%; height: auto; width: 100%;}
      }
      .amount-honey {
        color: #9B9B9B;
        display: inline-block;
        margin-left: 15px;
        width: calc(100% - 135px);
        .cur-total {
          border-bottom: 1px solid #EFEFEF;
          padding-bottom: 10px;
          // margin-bottom: 10px;
          div:first-child {padding-bottom: 10px;}
          div:last-child {color: #9F6A28; font-size: 20px; font-weight: bold;}
        }
        .use-total {
          padding-top: 10px;
          div:first-child {padding-bottom: 10px;}
          div:last-child {color: #4B2D15; font-size: 20px; font-weight: bold;}
        }
      }
    }
  }
  .card-store {
    margin-bottom: 5px;
    margin-top: 15px;
    border-radius: 5px;
    .box-honey-store {

    }
  }
  .btn-honey-list {
    .btn-honey-add-request {
      background-color: #FFD311;
      width: 214px;
      height: 48px;
      border-radius: 5px;
      color: black;
      text-transform: none;
      font-size: 14px;
      font-family: 'adobe-clean' sans-serif;
      border: 1px solid #FFD311;
      padding: 0;
      &:active {
        background-color: #CCAD7B;
        color: black;
      }
    }
    .btn-honey-manage-request {
      background-color: #FAFAFA;
      width: 214px;
      height: 48px;
      border-radius: 5px;
      color: black;
      text-transform: none;
      font-size: 14px;
      font-family: 'adobe-clean' sans-serif;
      border: 1px solid #FAFAFA;
      padding: 0;
      margin-left: 15px;
      &:active {
        background-color: #EAEAEA;
        color: black;
      }
    }
  }
  .card-honey-action {
    margin-top: 5px;
    .card-content {
      .box-list-honey {
        .box-honey-header {
            padding: 10px 0;
            font-size: 15px;
            font-weight: bold;
            font-family: 'Helvetica' sans-serif;
            span:nth-child(2) {padding-left: 30px;}
            span:last-child {float:right;padding-right: 110px;}
        }
        .box-honey-scroll {
          overflow-y: scroll;
          height: 520px;
          &::-webkit-scrollbar {
            width: 10px;
	          background-color: #F5F5F5;
          }
          &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	          background-color: #F5F5F5;
	          border-radius: 10px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #F90;	
	          background-image: -webkit-linear-gradient(45deg,rgba(255, 255, 255, .2) 25%,
											  transparent 25%,
											  transparent 50%,
											  rgba(255, 255, 255, .2) 50%,
											  rgba(255, 255, 255, .2) 75%,
											  transparent 75%,
											  transparent)
          }

          /* Handle on hover */
          &::-webkit-scrollbar-thumb:hover {
            background: #555; 
          }
          .box-honey-items {
            border-top: 1px solid #00000029;
            padding: 20px 0 10px;
            position: relative;
            &:nth-last-child(1) {border-bottom: 1px solid #00000029;}
            span:first-child {position: absolute;}
            span:nth-child(2) {
              padding-left: 58px;
              a.link-object {color: #1A0DAB; cursor: pointer;}
            }
            span.plus {color: #3A9F00;}
            span.minus {color: #D63131;}
            span:last-child {position: absolute; right: 50px;}
          }
        }
      }
      .box-list-honey-kanban {
        .box-kanban-honey-default {display: none;}
        .box-kanban-honey {display:none;}
      }
      .box-honey-pagination {}
    }
  }
}
@media (max-width: 414px) {
  .honey-content {
    padding-top: 30px !important;
  }
  .honey-body {
    .btn-honey-list {
      .btn-honey-add-request {
        width: 168px;
      }
      .btn-honey-manage-request {
        width: 168px;
        position:absolute;
        right: 15px;
      }
    }
    .card-honey-action {
      .card-content {
        .box-list-honey {
          .box-honey-header {display: none;}
          .box-honey-scroll {display: none;}
        }
        .box-list-honey-kanban {
          .box-kanban-honey-default {
            display: block;
            width: 100%;
            height: auto;
            font-weight: bold;
            background-color: #FAFAFA;
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #E0E0E0;
            opacity: 1;
            font-size: 15px;
          }
          .box-honey-scroll-kanban {
            overflow-y: scroll;
            height: 300px;
            &::-webkit-scrollbar {
              width: 10px;
              background-color: #F5F5F5;
            }
            &::-webkit-scrollbar-track {
              -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
              background-color: #F5F5F5;
              border-radius: 10px;
            }
            &::-webkit-scrollbar-thumb {
              border-radius: 10px;
              // background-image: -webkit-gradient(linear,
              // 			   left bottom,
              // 			   left top,
              // 			   color-stop(0.44, rgb(122,153,217)),
              // 			   color-stop(0.72, rgb(73,125,189)),
              // 			   color-stop(0.86, rgb(28,58,148)));

              background-color: #F90;	
              background-image: -webkit-linear-gradient(45deg,rgba(255, 255, 255, .2) 25%,
                          transparent 25%,
                          transparent 50%,
                          rgba(255, 255, 255, .2) 50%,
                          rgba(255, 255, 255, .2) 75%,
                          transparent 75%,
                          transparent)
            }

            /* Handle on hover */
            &::-webkit-scrollbar-thumb:hover {
              background: #555; 
            }
            .box-kanban-honey {
              display: block;
              width: 100%;
              height: auto;
              background-color: #FAFAFA;
              padding: 10px;
              border-radius: 5px;
              border: 1px solid #E0E0E0;
              opacity: 1;
              font-size: 15px;
              margin: 5px 0 10px;
              &:last-child {margin: 5px 0 5px;}
              div:first-child {
                padding-bottom: 5px;
                a.link-object {color: #1A0DAB;}
                span.plus {color: #3A9F00;}
                span.minus {color: #D63131;}
              }
              div:nth-child(2) {color:#969FAD;}
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// HoneyJars.vue?8a66424c